import { GET_MOVIMENTO } from "./types";

export default {
    [GET_MOVIMENTO](state) {
        return state.movCaixaEntradaManual;
    },
}